export default "__VITE_ASSET__CeOc3Zgt__"